export default {"src":"/_next/static/media/sd.d30c3b2e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};